import { CustomRoutes } from '@shared/consts/routes/custom-routes.const';
import { ProjectTasksComponent } from '@project-modules/project-tasks/pages/project-tasks/project-tasks.component';

export const ProjectTasksRoutes: CustomRoutes = [
  {
    path: '',
    component: ProjectTasksComponent,
  },
];
